import Alpine from 'alpinejs'

Alpine.data('productSprite', (spriteUrl, width, height, cols, rows, panSpeed, duration) => ({

    canvasStyle: 'width:'+width+'px;height:'+height+'px',

    state: {
        frame: 0,
        col: 0,
        row: 0,
        loaded: false,
        playback: null,
        panMove: null,
        panMoveFrame: null,
        hasTrackedScrub: false,
    },
    config: {
        spriteUrl: spriteUrl,
        width: width,
        height: height,
        cols: cols,
        rows: rows,
        frames: cols * rows,
        panSpeed: panSpeed,
        duration: duration
    },

    panStart(position) {
        this.state.panMove = position
        this.state.panMoveFrame = this.state.frame
    },
    panMove(position) {
        if(this.state.panMove === null) {
            return
        }
        const panDelta = this.state.panMove - position
        if(this.state.playback && panDelta !== 0) {
            this.stop()
        }
        const frame = this.state.panMoveFrame + Math.round(panDelta / this.config.panSpeed)
        this.setFrame(frame)

        if(!this.state.hasTrackedScrub && Math.abs(panDelta) > 100) {
            window.gtag('event', 'product_360_scrub')
            this.state.hasTrackedScrub = true
        }
    },
    panEnd(position) {
        if(this.state.panMove === null) {
            return
        }

        const panDelta = this.state.panMove - position
        this.state.panMove = null
        this.state.panMoveFrame = null

        if(panDelta === 0) {
            if(this.state.playback) {
                this.stop()
            } else {
                this.playback(this.state.frame+1 === this.config.frames)
            }
        }
    },
    load() {
        if(this.state.loaded) {
            return
        }
        this.canvasStyle = 'width:'+width +'px;'
            +'height:'+height+'px;'
            +'background-image:url('+this.config.spriteUrl+')'

        this.state.loaded = true
    },
    start() {
        this.load()
        this.stop()
        this.playback(true)
    },
    playback(resetFrame) {
        if(this.state.playback) {
            return
        }

        this.state.panMove = null
        this.state.panMoveFrame = null

        if(resetFrame) {
            this.setFrame(0)
        }
        this.state.playback = window.setInterval(() => this.playbackNextFrame(), this.config.duration)
    },
    playbackNextFrame() {
        const next = this.state.frame+1
        if(next === this.config.frames) {
            this.stop()
            return
        }
        this.setFrame(next)

    },
    stop() {
        if(this.state.playback) {
            window.clearInterval(this.state.playback)
            this.state.playback = null
        }
    },
    setFrame(frame) {
        this.state.frame = frame % this.config.frames
        this.state.row = Math.floor(frame / this.config.cols)
        this.state.col = this.state.frame % this.config.cols

        this.canvasStyle = 'width:'+width +'px;'
            +'height:'+height+'px;'
            +'background-image:url(\''+this.config.spriteUrl+'\');'
            +'background-position:'
            +(this.state.col * -this.config.width)+'px '
            +(this.state.row * -this.config.height)+'px;'
    }

}))